import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { choices } from "../config-generics/aeKao";

export const financialConfig: PageConfig[] = [
  {
    name: "financialReport",
    title: "Financial Report",
    questions: [
      {
        type: "matrixdynamic",
        name: "income",
        title: "Income / Funds",
        description: "All $ Ex GST",
        addRowText: "Add Row",
        columnMinWidth: "130px",
        columns: [
          {
            name: "incomeFunder",
            title: "Funding Source",
            cellType: "text",
            isRequired: true,
          },
          {
            name: "incomeAmount",
            title: "Amount",
            cellType: "text",
            isRequired: true,
            totalType: "sum",
            // eslint-disable-next-line no-template-curly-in-string
            totalFormat: "Total: ${0}",
            inputType: "number",
          },
        ],
        rowCount: 1,
        minRowCount: 1,
        maxRowCount: 100,
      },
    ],
  },
  {
    name: "expenditure",
    title: "Expenditure",
    questions: [
      {
        type: "matrixdynamic",
        name: "expenditure",
        title: "Expenditure",
        description: "All $ Ex GST",
        addRowText: "Add Row",
        columnMinWidth: "130px",
        columns: [
          {
            name: "expenditureType",
            title: "Expenditure Type",
            isRequired: true,
            choices: [
              "Communications",
              "Catering",
              "Transport",
              "Venue Hire",
              "Equipment Hire / Purchase",
              "Other",
            ],
          },
          {
            name: "expenditureDetails",
            title: "Description or Provider Name",
            cellType: "text",
            isRequired: true,
          },
          {
            name: "expenditureAmount",
            title: "Amount",
            cellType: "text",
            isRequired: true,
            totalType: "sum",
            // eslint-disable-next-line no-template-curly-in-string
            totalFormat: "Total: ${0}",
            inputType: "number",
            totalAlignment: "right",
          },
        ],
        rowCount: 1,
        minRowCount: 1,
        maxRowCount: 100,
      },
    ],
  },
  {
    name: "financialSummary",
    title: "Financial Summary",
    questions: [
      {
        type: "expression",
        name: "summaryExpenditure",
        title: "Total Event Cost",
        expression: "{expenditure-total.expenditureAmount}",
        displayStyle: "currency",
        currency: "NZD",
      },
      {
        type: "expression",
        name: "summaryIncome",
        title: "Total Income Received",
        expression: "{income-total.incomeAmount}",
        displayStyle: "currency",
        startWithNewLine: false,
        currency: "NZD",
      },
      {
        type: "expression",
        name: "shortfall",
        title: "Shortfall",
        expression:
          "{expenditure-total.expenditureAmount} - {income-total.incomeAmount}",
        displayStyle: "currency",
        startWithNewLine: false,
        currency: "NZD",
      },
    ],
  },
  {
    name: "receipts",
    title: "Receipts",
    questions: [
      {
        type: "file",
        name: "receipts",
        title: "Please attach GST receipts for all expenses.",
        storeDataAsText: false,
        allowMultiple: true,
        maxSize: 10485760,
        waitForUpload: true,
      },
    ],
  },
  {
    name: "fundUse",
    title: "Use of Funds",
    questions: [
      {
        name: "fundUse",
        title:
          "Where all funds from the Whānau Initiatives Fund used as agreed?",
        type: "radiogroup",
        choices,
        isRequired: true,
      },
    ],
  },
];
